import { Difficulty } from "../../../Difficulty";

export const canYouPanOptions: {
  [difficulty in Difficulty]: {
    panOptions: number[];
    steps: number;
  };
} = {
  easy: {
    steps: 90,
    panOptions: [-90, 0, 90],
  },
  medium: {
    steps: 45,
    panOptions: [-90, -45, 0, 45, 90],
  },
  hard: {
    steps: 15,
    panOptions: [-90, -75, -60, -45, -30, -15, 0, 15, 30, 45, 60, 75, 90],
  },
};
